// TODO - remove lint disable when editing this file
/* eslint-disable */
import React from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { compose, withHandlers, withState, defaultProps } from 'recompose'
import intl from 'react-intl-universal'

import styles from './WorkflowModal.scss'

export const _handlers = {
  handleSave: (props) => () => {
    props.onSave({ note: props.note, status: props.status })
  },
  handleSaveAndExit: (props) => () => {
    props.onSave({ note: props.note, status: props.status }, true)
  },
  handleNoteChange: (props) => (event) => {
    props.updateNote(event.target.value)
  },
  handleStatusChange: (props) => (event) => {
    props.updateStatus(Number(event.target.value))
  },
}

export function WorkflowModal(props) {
  const {
    webskedButtons,
    note,
    status,
    isOpen,
    onClose,
    handleSave,
    handleSaveAndExit,
    handleNoteChange,
    handleStatusChange,
  } = props

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        {intl.get('WorkflowModal.header')}
      </ModalHeader>

      <ModalBody className="form p-2 meta-boolean">
        <div className={styles.radioWrapper}>
          {webskedButtons.map((button, index) => (
            <div key={`${button.name}-${index}`} className="form-check">
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  type="radio"
                  value={button.id}
                  onChange={handleStatusChange}
                  checked={button.id === status}
                />
                {button.name}
              </label>
            </div>
          ))}
        </div>

        <div className="form-group">
          <label>{intl.get('WorkflowModal.note')}</label>
          <textarea
            className="form-control"
            rows="4"
            value={note}
            onChange={handleNoteChange}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <button
          data-testid="editor-websked-workflow-status-cancel-btn"
          className="btn btn-outline-secondary"
          onClick={onClose}
        >
          {intl.get('WorkflowModal.cancel')}
        </button>
        <button
          data-testid="editor-websked-workflow-status-save-btn"
          className="btn btn-outline-primary"
          onClick={handleSave}
        >
          {intl.get('WorkflowModal.save')}
        </button>
        <button
          data-testid="editor-websked-workflow-status-save-exit-btn"
          className="btn btn-success"
          onClick={handleSaveAndExit}
        >
          {intl.get('WorkflowModal.saveAndExit')}
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default compose(
  defaultProps({ note: '' }),
  withState('note', 'updateNote', (props) => props.note),
  withState('status', 'updateStatus', (props) => props.statusCode),
  withHandlers(_handlers)
)(WorkflowModal)
